import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DeployTime } from 'src/environments/deploytime';
import { LogsService } from '../../services/logs.service';

@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class AboutDialogComponent {
  version: string;
  deployDate: string;

  constructor(
    public dialogRef: MatDialogRef<AboutDialogComponent>,
    private logsService: LogsService
  ) {
    const deployTime = DeployTime.getInstance(this.logsService);
    this.version = deployTime.getLastCommitId();
    this.deployDate = deployTime.getFormattedStartupDate();
    dialogRef.addPanelClass('about-dialog-container');
  }
}